
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FileDto } from 'src/app/data/models/dto/file.dto';

@Component({
  selector: 'app-show-first-step',
  templateUrl: './show-first-step.component.html',
  styleUrls: ['./show-first-step.component.scss']
})
export class ShowFirstStepComponent implements OnInit{
  @Input() firstFormGroup: FormGroup = this.fb.group({});
  @Output() deleteFiles = new EventEmitter<FileDto[]>();

  minDate = new Date();

  attachments: any[] = [];
  attachmentsToDelete: FileDto[] = [];
  currentAttachments: any[] = [];
  bgFiles: any[] = [];
  bgFilesToDelete: FileDto[] = [];
  currentBgFiles: any[] = [];
  backgroundFilePath = '';
  attachmentsPath = '';

  constructor(
    private readonly fb: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.loadFiles();
  }

  onCurrentAttachmentsEmit(emit: FileDto[]) {
    this.firstFormGroup.controls['urlImage'].setValue(emit[0])
  }

  onBackgroundFileToDeleteEmit(emit: FileDto[]) {
    this.bgFilesToDelete.push(...emit);
    this.deleteFiles.emit(this.bgFilesToDelete);
  }

  loadFiles() {
    this.bgFiles = this.firstFormGroup.controls['urlImage'].value
      ? [this.firstFormGroup.controls['urlImage'].value]
      : [];
    this.currentBgFiles = this.bgFiles;
  }
}
